import './App.css';
import Index from './components/index';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Router basename={'front'}>
        <Index/>
      </Router>
    </div>
  );
}

export default App;
